import React, { FC } from 'react';
import { Image } from '../Image';
import styles from './EsgPolicyCard.module.scss';

interface Props {
  EsgPolicyCardData: { [key: string]: string };
}
const EsgPolicyCard: FC<Props> = (props) => {
  const { EsgPolicyCardData } = props;
  const { zhTitle, zhFileAddress, enTitle, enFileAddress } = EsgPolicyCardData;

  const Icon = (
    <div className={styles.image}>
      <Image src="https://p0.meituan.net/smartvenus/8080974872c772f50926404b0ae0ce5e1804.png" layout="fill" />
    </div>
  );
  return (
    <>
      <div className={styles['esg-policy-container']}>
        <div className={styles['esg-policy-text-container']}>
          <div className={styles['esg-policy-zh-title']}>{zhTitle}</div>
          <div className={styles['esg-policy-en-title']}>{enTitle}</div>
        </div>
        <div className={styles.divider} />
        <div className={styles['esg-policy-footer']}>
          <div className={styles['esg-policy-footer-module']}>
            <a href={zhFileAddress} target="_blank" rel="noreferrer">
              {Icon}
              中文版
            </a>
          </div>
          <div className={styles['esg-policy-footer-module']}>
            <a href={enFileAddress} target="_blank" rel="noreferrer">
              {Icon}
              English Version
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default EsgPolicyCard;
